module.exports = __webpack_public_path__ + "static/P2101570-32084d10befeb1c5198e85fe384af8ed.jpg";